import React from 'react';
import Editor from 'react-codemirror';
import Messages from '../../../configurations/messages';
import ScriptsApi from '../../../api/ScriptsApi';
import Modal from '../../common/modal';
import ConnectedButton from  '../../common/connectedButton';
import Permissions from '../../../configurations/permissions';
import Toaster from 'toastr';
import '../../../../node_modules/codemirror/lib/codemirror.css';
import '../../../../node_modules/codemirror/mode/groovy/groovy.js';


class ScriptsModal extends React.Component {


    constructor(props, context) {
        super(props, context);

        this.state = {
            scriptObj: props.script,
            updating: false,
            currentScript: props.script ? props.script.source : "",
            scriptTitle: props.script ? props.script.name : ""
        };
        this.onChange = this.onChange.bind(this);
    }

    onChange(val) {
        this.setState({
            currentScript: val
        });
    }
    handleUpdate(evt) {
        this.setState({ updating: true });
    
        ScriptsApi.updateScript(this.state.scriptObj.id, {
            source: this.state.currentScript
        }).then((response) => {
            Toaster.success(`Script ${this.state.scriptObj.name} - successfully updated`);
            this.setState({ updating: false });
            this.props.onRequestClose(evt, true);
        })
            .catch((error) => {
                console.log(error);
                Toaster.error(`${error.data ? error.data.description : error.statusText}`, `${Messages.ERROR_SCRIPT_UPDATE} - ${error.status}`);
                this.setState({ updating: false });
            })
    }


    render() {
       
        return (
            <Modal title={this.state.scriptTitle} isOpen={this.props.isOpen} onRequestClose={this.props.onRequestClose}>
                <div className="row">
                    <div className="col-md-12">
                        <Editor
                            name="scriptEditor"
                            onChange={this.onChange}
                            
                            value={this.state.currentScript}

                            options={{
                                mode : 'groovy',
                                lineNumbers : true,
                                readOnly : this.state.updating
                            }} />

                    </div>

                </div>
                <div className="mod-footer">
                    <div className="mod-footer-buttons">
                        <ConnectedButton 
                            onClick={(evt) => { this.handleUpdate(evt); }} 
                            disabled={this.state.updating} 
                            allowedPermissions={[Permissions.UPDATE_SCRIPT]}
                            className="btn btn-primary">UPDATE</ConnectedButton>
                        <button onClick={(evt) => { this.props.onRequestClose(evt); }} disabled={this.state.updating} className="btn btn-danger">CLOSE</button>
                    </div>
                </div>
            </Modal>
        )
    }

}

export default ScriptsModal;


// WEBPACK FOOTER //
// ./src/components/admin/scripts/scriptsModal.js